import React from 'react';
import { Link } from '@material-ui/core';

import theme from '../../theme';
import messages from './messages';

import Typography from '../Typography/Typography';

const styles = {
  recaptchaNotice: {
    marginTop: theme.spacing(2),
    fontSize: '0.75rem',
  },
  policyLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 500,
    transition: 'color 0.2s',
    '&:hover': {
      color: theme.palette.primary.dark,
      textDecoration: 'underline',
    },
  },
};

const GoogleRecaptchaNotice = () => (
  <Typography
    color="textSecondary"
    style={styles.recaptchaNotice}
    content={messages.notice}
    values={{
      privacyPolicy: (
        <Link
          href="https://policies.google.com/privacy"
          style={styles.policyLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography variant="caption" component="span" content={messages.privacyPolicy} />
        </Link>
      ),
      termsOfService: (
        <Link
          href="https://policies.google.com/terms"
          style={styles.policyLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography variant="caption" component="span" content={messages.termsOfService} />
        </Link>
      ),
    }}
  />
);

export default GoogleRecaptchaNotice;
